module.exports = __webpack_public_path__ + "media/educator_advisory_board/Ryan_Rodriguez-bc3a8f78.png";